module.exports = __webpack_public_path__ + "static/media/icon-1.7a696b41.svg";